export default {
  setError403(state, status) {
    state.error403 = status
  },

  setError404(state, status) {
    state.error404 = status
  },

  setError429(state, status) {
    state.error429 = status
  },

  setError500(state, status) {
    state.error500 = status
  },

  setShowMenu(state, status) {
    state.showMenu = status
  },

  toggleMenu(state) {
    state.showMenu = !state.showMenu
  },
}
